import React from "react";
import { BiSolidMessageAdd } from "react-icons/bi";
import "./AddNote.css";
import { Tooltip } from "../Tooltip";

export function AddNote({ onClick }) {
  return (
    <Tooltip text="Add Note">
      <button onClick={onClick} className="add-note-button">
        <BiSolidMessageAdd />
      </button>
    </Tooltip>
  );
}
